import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
    reassignTickets,
    reassignTicketsFailure,
    reassignTicketsSuccessfully
} from 'src/app/root-store/ticket-store/actions/tickets.actions';
import { TicketService } from 'src/app/travelx/tickets/ticket.service';

@Injectable()
export class TicketGridEffects {
    constructor(private readonly _actions$: Actions, private readonly _ticketService: TicketService) {}

    reassignTickets$ = createEffect(() =>
        this._actions$.pipe(
            ofType(reassignTickets),
            switchMap((action) => {
                return this._ticketService.reassignTickets(action.assigneeId, action.ticketIds).pipe(
                    map(() => reassignTicketsSuccessfully()),
                    catchError((error) => of(reassignTicketsFailure({ error })))
                );
            })
        )
    );
}
